import { useTranslation } from '@supply-mover-2-0/web-ui';

/**
 * Generic 404 page used when the portal can't be found or the URL is invalid.
 * Intentionally minimal — no details about why the page wasn't found,
 * just a clean dead-end so the user knows to check their URL.
 */
export function NotFoundPage(): JSX.Element {
	const { t } = useTranslation();

	return (
		<div className="min-h-dvh flex items-center justify-center bg-brand-page-bg px-4">
			<div className="text-center">
				<h1 className="text-6xl font-bold text-gray-300 dark:text-gray-700 mb-4">
					{t('404')}
				</h1>
				<p className="text-lg text-gray-600 dark:text-gray-400 mb-2">
					{t('Page not found')}
				</p>
				<p className="text-sm text-gray-500 dark:text-gray-500">
					{t(
						'The page you are looking for does not exist or is no longer available.',
					)}
				</p>
			</div>
		</div>
	);
}
